import {
  SUGGEST_NAME_REQUEST,
  SUGGEST_NAME_SUCCESS,
  SUGGEST_NAME_FAILURE,
  CLEAR_SUGGESTED_NAME
} from '../actions/utilities';

const initialState = {
  suggestedName: null,
  isLoadingName: false,
  nameError: null
};

const utilitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUGGEST_NAME_REQUEST:
      return {
        ...state,
        isLoadingName: true,
        nameError: null
      };
      
    case SUGGEST_NAME_SUCCESS:
      return {
        ...state,
        suggestedName: action.payload,
        isLoadingName: false,
        nameError: null
      };
      
    case SUGGEST_NAME_FAILURE:
      return {
        ...state,
        suggestedName: null,
        isLoadingName: false,
        nameError: action.payload
      };
      
    case CLEAR_SUGGESTED_NAME:
      return {
        ...state,
        suggestedName: null,
        nameError: null
      };
      
    default:
      return state;
  }
};

export default utilitiesReducer;
